import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { jsonpRequest } from '../../../browser/utils/jsonpRequest';
import { EEventType } from '../../types/events';
import { EActiveView } from '../../types/view';
import { changeView } from '../view';
import { trackAuthenticateSuccess } from '../../utils/tracking';
import { EAuthenticateByTokenStatus } from '../../types/phoneAuth';
import { fetchAuthorizeUserByToken } from '../../repositories/users/v1/authorize-user-by-token';
import { PHONE_AUTH_AUTHENTICATE_BY_TOKEN } from '../../constants/action_types';
import { saveAccount } from '../../utils/rememberedAccounts';
import { ERememberedAccountType } from '../../types/rememberedAccounts';
import { formatPhoneWithSpecialChars } from '../../utils/formatString';
export function authenticateByToken(_ref) {
  var email = _ref.email,
    password = _ref.password,
    phone = _ref.phone;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var _getState, temporaryToken, isRememberAccountsFlow, source, res, _res$response, logOnUrl, token, needCheckPassword;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch({
              status: EAuthenticateByTokenStatus.Loading,
              type: PHONE_AUTH_AUTHENTICATE_BY_TOKEN,
              account: email
            });
            _context.prev = 1;
            _getState = getState(), temporaryToken = _getState.phoneAuth.registerOrAuth.temporaryToken, isRememberAccountsFlow = _getState.isRememberAccountsFlow, source = _getState.source;
            _context.next = 5;
            return fetchAuthorizeUserByToken({
              httpApi: context.httpApi,
              parameters: {
                email: email,
                password: password,
                temporaryToken: temporaryToken
              },
              config: {
                requestConfig: {
                  headers: [['Content-Type', 'application/json']],
                  withCredentials: true
                }
              }
            });
          case 5:
            res = _context.sent;
            if (!(res.statusCode === 200)) {
              _context.next = 29;
              break;
            }
            _res$response = res.response, logOnUrl = _res$response.logOnUrl, token = _res$response.token, needCheckPassword = _res$response.needCheckPassword;
            if (!needCheckPassword) {
              _context.next = 12;
              break;
            }
            dispatch({
              type: PHONE_AUTH_AUTHENTICATE_BY_TOKEN,
              status: EAuthenticateByTokenStatus.Suspended
            });
            dispatch(changeView(EActiveView.ConfirmSelectedAccount));
            return _context.abrupt("return");
          case 12:
            _context.prev = 12;
            _context.next = 15;
            return jsonpRequest("".concat(logOnUrl, "?login=").concat(encodeURIComponent(email), "&token=").concat(token, "&persistent=true"));
          case 15:
            dispatch({
              status: EAuthenticateByTokenStatus.Succeed,
              type: PHONE_AUTH_AUTHENTICATE_BY_TOKEN
            });
            context.emitter.emit(EEventType.AuthenticateSucceed);
            trackAuthenticateSuccess({
              socialType: 'email',
              source: source
            });
            if (isRememberAccountsFlow) {
              if (phone) {
                saveAccount({
                  type: ERememberedAccountType.Phone,
                  value: formatPhoneWithSpecialChars(phone)
                });
              } else {
                saveAccount({
                  type: ERememberedAccountType.Email,
                  value: email
                });
              }
            }
            _context.next = 26;
            break;
          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](12);
            context.logger.error(_context.t0, {
              domain: 'auth-widget.api.authenticateByToken#logon'
            });
            dispatch({
              type: PHONE_AUTH_AUTHENTICATE_BY_TOKEN,
              status: EAuthenticateByTokenStatus.Failed,
              error: 'Произошла непредвиденная ошибка'
            });
            if (!password) {
              dispatch(changeView(EActiveView.AccountSelectError));
            }
          case 26:
            return _context.abrupt("return");
          case 29:
            if (res.statusCode === 400 && res.response.errors.some(function (error) {
              return error.code.includes('tokenExpired');
            })) {
              dispatch({
                type: PHONE_AUTH_AUTHENTICATE_BY_TOKEN,
                status: EAuthenticateByTokenStatus.Failed,
                error: res.response.message
              });
              dispatch(changeView(EActiveView.TokenExpiredError));
            } else if (res.statusCode === 400 && res.response.errors.some(function (error) {
              return error.code.includes('invalidPassword') || error.code.includes('passwordInvalidated');
            })) {
              dispatch({
                type: PHONE_AUTH_AUTHENTICATE_BY_TOKEN,
                status: EAuthenticateByTokenStatus.Failed,
                error: res.response.message
              });
            } else {
              context.logger.error("\u041D\u0435\u043F\u0440\u0435\u0434\u0432\u0438\u0434\u0435\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430, response: ".concat(JSON.stringify(res.response)));
              dispatch({
                type: PHONE_AUTH_AUTHENTICATE_BY_TOKEN,
                status: EAuthenticateByTokenStatus.Failed,
                error: 'Произошла непредвиденная ошибка'
              });
              if (!password) {
                dispatch(changeView(EActiveView.AccountSelectError));
              }
            }
          case 30:
            _context.next = 37;
            break;
          case 32:
            _context.prev = 32;
            _context.t1 = _context["catch"](1);
            context.logger.error(_context.t1, {
              domain: 'auth-widget.api.authenticateByToken'
            });
            dispatch({
              type: PHONE_AUTH_AUTHENTICATE_BY_TOKEN,
              status: EAuthenticateByTokenStatus.Failed,
              error: 'Произошла непредвиденная ошибка'
            });
            if (!password) {
              dispatch(changeView(EActiveView.AccountSelectError));
            }
          case 37:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 32], [12, 21]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
}